<template>
  <button
    :disabled="disabled"
    class="base__btn btn"
    :class="[isPrimary ? 'btn-primary' : 'btn-default']"
    v-on:click="onClick"
    :id="buttonid"
  >
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    },
    buttonid: {
      type: String,
      default: " "
    }
  },
  methods: {
    onClick(event) {
      this.$emit("onClick", event);
    }
  }
};
</script>

<style lang="scss" scoped>
.base {
  &__btn {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    height: 49px;
    font-size: 16px;
    font-family: $body;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.75px;
    line-height: 24px;
  }
}
</style>
